import { configureStore } from '@reduxjs/toolkit';
import matchSelectionFilterReducer from '../features/MatchSelectionFilter/MatchSelectionFilterSlice'

const store = configureStore({
    reducer: {
        matchSelectionFilter: matchSelectionFilterReducer
    }
});

export default store;